/**
 * @fileoverview gRPC-Web generated client stub for evidence
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: evidence/service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.evidence = require('./service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.evidence.EvidenceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.evidence.EvidenceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_EvidenceService_ScanAllReceptors = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/ScanAllReceptors',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.scanAllReceptors =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/ScanAllReceptors',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_ScanAllReceptors,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.scanAllReceptors =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/ScanAllReceptors',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_ScanAllReceptors);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.CreateOrphanedManualEvidenceRequest,
 *   !proto.evidence.CreateManualEvidenceResponse>}
 */
const methodDescriptor_EvidenceService_CreateOrphanedManualEvidence = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/CreateOrphanedManualEvidence',
  grpc.web.MethodType.UNARY,
  proto.evidence.CreateOrphanedManualEvidenceRequest,
  proto.evidence.CreateManualEvidenceResponse,
  /**
   * @param {!proto.evidence.CreateOrphanedManualEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidence.CreateManualEvidenceResponse.deserializeBinary
);


/**
 * @param {!proto.evidence.CreateOrphanedManualEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidence.CreateManualEvidenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidence.CreateManualEvidenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.createOrphanedManualEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/CreateOrphanedManualEvidence',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_CreateOrphanedManualEvidence,
      callback);
};


/**
 * @param {!proto.evidence.CreateOrphanedManualEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidence.CreateManualEvidenceResponse>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.createOrphanedManualEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/CreateOrphanedManualEvidence',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_CreateOrphanedManualEvidence);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.CreateControlManualEvidenceRequest,
 *   !proto.evidence.CreateManualEvidenceResponse>}
 */
const methodDescriptor_EvidenceService_CreateControlManualEvidence = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/CreateControlManualEvidence',
  grpc.web.MethodType.UNARY,
  proto.evidence.CreateControlManualEvidenceRequest,
  proto.evidence.CreateManualEvidenceResponse,
  /**
   * @param {!proto.evidence.CreateControlManualEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidence.CreateManualEvidenceResponse.deserializeBinary
);


/**
 * @param {!proto.evidence.CreateControlManualEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidence.CreateManualEvidenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidence.CreateManualEvidenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.createControlManualEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/CreateControlManualEvidence',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_CreateControlManualEvidence,
      callback);
};


/**
 * @param {!proto.evidence.CreateControlManualEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidence.CreateManualEvidenceResponse>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.createControlManualEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/CreateControlManualEvidence',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_CreateControlManualEvidence);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.CreateRequestManualEvidenceRequest,
 *   !proto.evidence.CreateManualEvidenceResponse>}
 */
const methodDescriptor_EvidenceService_CreateRequestManualEvidence = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/CreateRequestManualEvidence',
  grpc.web.MethodType.UNARY,
  proto.evidence.CreateRequestManualEvidenceRequest,
  proto.evidence.CreateManualEvidenceResponse,
  /**
   * @param {!proto.evidence.CreateRequestManualEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidence.CreateManualEvidenceResponse.deserializeBinary
);


/**
 * @param {!proto.evidence.CreateRequestManualEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidence.CreateManualEvidenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidence.CreateManualEvidenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.createRequestManualEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/CreateRequestManualEvidence',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_CreateRequestManualEvidence,
      callback);
};


/**
 * @param {!proto.evidence.CreateRequestManualEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidence.CreateManualEvidenceResponse>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.createRequestManualEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/CreateRequestManualEvidence',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_CreateRequestManualEvidence);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.UpdateRelevantDateRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_EvidenceService_UpdateRelevantDate = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/UpdateRelevantDate',
  grpc.web.MethodType.UNARY,
  proto.evidence.UpdateRelevantDateRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.evidence.UpdateRelevantDateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.evidence.UpdateRelevantDateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.updateRelevantDate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/UpdateRelevantDate',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_UpdateRelevantDate,
      callback);
};


/**
 * @param {!proto.evidence.UpdateRelevantDateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.updateRelevantDate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/UpdateRelevantDate',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_UpdateRelevantDate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.GetRelevantDateFilterRequest,
 *   !proto.evidence.GetRelevantDateFilterResponse>}
 */
const methodDescriptor_EvidenceService_GetRelevantDateFilter = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/GetRelevantDateFilter',
  grpc.web.MethodType.UNARY,
  proto.evidence.GetRelevantDateFilterRequest,
  proto.evidence.GetRelevantDateFilterResponse,
  /**
   * @param {!proto.evidence.GetRelevantDateFilterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidence.GetRelevantDateFilterResponse.deserializeBinary
);


/**
 * @param {!proto.evidence.GetRelevantDateFilterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidence.GetRelevantDateFilterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidence.GetRelevantDateFilterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.getRelevantDateFilter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/GetRelevantDateFilter',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_GetRelevantDateFilter,
      callback);
};


/**
 * @param {!proto.evidence.GetRelevantDateFilterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidence.GetRelevantDateFilterResponse>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.getRelevantDateFilter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/GetRelevantDateFilter',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_GetRelevantDateFilter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.UpdateCaptionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_EvidenceService_UpdateCaption = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/UpdateCaption',
  grpc.web.MethodType.UNARY,
  proto.evidence.UpdateCaptionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.evidence.UpdateCaptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.evidence.UpdateCaptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.updateCaption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/UpdateCaption',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_UpdateCaption,
      callback);
};


/**
 * @param {!proto.evidence.UpdateCaptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.updateCaption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/UpdateCaption',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_UpdateCaption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.DeleteEvidenceInstanceRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_EvidenceService_DeleteEvidenceInstance = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/DeleteEvidenceInstance',
  grpc.web.MethodType.UNARY,
  proto.evidence.DeleteEvidenceInstanceRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.evidence.DeleteEvidenceInstanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.evidence.DeleteEvidenceInstanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.deleteEvidenceInstance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/DeleteEvidenceInstance',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_DeleteEvidenceInstance,
      callback);
};


/**
 * @param {!proto.evidence.DeleteEvidenceInstanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.deleteEvidenceInstance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/DeleteEvidenceInstance',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_DeleteEvidenceInstance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.DeleteEvidenceRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_EvidenceService_DeleteEvidence = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/DeleteEvidence',
  grpc.web.MethodType.UNARY,
  proto.evidence.DeleteEvidenceRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.evidence.DeleteEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.evidence.DeleteEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.deleteEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/DeleteEvidence',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_DeleteEvidence,
      callback);
};


/**
 * @param {!proto.evidence.DeleteEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.deleteEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/DeleteEvidence',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_DeleteEvidence);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.evidence.ListEvidenceBeingIndexedRequest,
 *   !proto.evidence.ListEvidenceBeingIndexedResponse>}
 */
const methodDescriptor_EvidenceService_ListEvidenceBeingIndexed = new grpc.web.MethodDescriptor(
  '/evidence.EvidenceService/ListEvidenceBeingIndexed',
  grpc.web.MethodType.UNARY,
  proto.evidence.ListEvidenceBeingIndexedRequest,
  proto.evidence.ListEvidenceBeingIndexedResponse,
  /**
   * @param {!proto.evidence.ListEvidenceBeingIndexedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.evidence.ListEvidenceBeingIndexedResponse.deserializeBinary
);


/**
 * @param {!proto.evidence.ListEvidenceBeingIndexedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.evidence.ListEvidenceBeingIndexedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.evidence.ListEvidenceBeingIndexedResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.evidence.EvidenceServiceClient.prototype.listEvidenceBeingIndexed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/evidence.EvidenceService/ListEvidenceBeingIndexed',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_ListEvidenceBeingIndexed,
      callback);
};


/**
 * @param {!proto.evidence.ListEvidenceBeingIndexedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.evidence.ListEvidenceBeingIndexedResponse>}
 *     Promise that resolves to the response
 */
proto.evidence.EvidenceServicePromiseClient.prototype.listEvidenceBeingIndexed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/evidence.EvidenceService/ListEvidenceBeingIndexed',
      request,
      metadata || {},
      methodDescriptor_EvidenceService_ListEvidenceBeingIndexed);
};


module.exports = proto.evidence;

